
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import FooterBranding from './FooterBranding';
import FooterLinks from './FooterLinks';
import Copyright from './Copyright';
import BusinessLinks from './BusinessLinks';
import SocialLinks from './SocialLinks';
import { isAuthenticated } from '@/utils/auth';
import TermsPrivacyDialog from '../business/reseller/TermsPrivacyDialog';

const Footer: React.FC = () => {
  const isLoggedIn = isAuthenticated();
  const location = useLocation();
  const isAdminSite = location.pathname.includes('/admin');
  
  // Define resource links based on authentication status and site type
  const resourceLinks = isAdminSite 
    ? [
        { label: 'Home', url: '/' },
        { label: 'Terms of Service', url: '/admin/business-setup?tab=terms' },
        { label: 'Privacy Policy', url: '/admin/business-setup?tab=privacy' },
        { label: 'FAQ', url: '/admin/business-setup?tab=faq' },
        { label: 'How It Works', url: '/admin/business-setup?tab=howItWorks' },
        { label: 'Contact', url: '/admin/business-setup?tab=contact' },
        { label: 'Support', url: '/admin/support' },
        { label: 'Knowledge Base', url: '/admin/knowledge-base' }
      ]
    : [
        { label: 'Home', url: '/' },
        { 
          label: 'Terms of Service', 
          url: '#',
          renderCustom: (
            <TermsPrivacyDialog type="terms">
              <span className="hover:text-primary-blue transition-colors cursor-pointer">Terms of Service</span>
            </TermsPrivacyDialog>
          )
        },
        { 
          label: 'Privacy Policy', 
          url: '#',
          renderCustom: (
            <TermsPrivacyDialog type="privacy">
              <span className="hover:text-primary-blue transition-colors cursor-pointer">Privacy Policy</span>
            </TermsPrivacyDialog>
          )
        },
        {
          label: 'FAQ',
          url: '/admin/business-setup?tab=faq',
        }
      ];

  const contactLinks = [
    { 
      label: 'support@referme.site', 
      url: 'mailto:support@referme.site', 
      isExternal: true 
    }
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 py-10 mt-auto border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="md:flex md:justify-between">
          <div className="flex items-center space-x-4 mb-6 md:mb-0">
            <FooterBranding />

            {/* Award Emblems - Only show on user dashboard */}
            {!isAdminSite && (
              <div className="flex space-x-4">
                <img 
                  src="/assets/74192c5a-ba76-4e08-9c4a-f98e75942d6c.png" 
                  alt="Great Award Emblem" 
                  className="h-20 w-20 object-contain"
                />
                <img 
                  src="/assets/e2e58de0-5228-4c21-8754-a52246e544e0.png" 
                  alt="100% Guaranteed Emblem" 
                  className="h-20 w-20 object-contain"
                />
                <img 
                  src="/assets/36c87bd9-7bdf-4413-bf74-70043278eb04.png" 
                  alt="Quality Guaranteed Emblem" 
                  className="h-20 w-20 object-contain"
                />
              </div>
            )}
          </div>
          
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 mt-8 md:mt-0">
            <FooterLinks title="Resources" links={resourceLinks} />
            {!isAdminSite && <FooterLinks title="Contact" links={contactLinks} />}
          </div>
        </div>
        
        <hr className="my-8 border-gray-300" />
        
        <div className="flex flex-col md:flex-row justify-between items-center">
          <Copyright />
          <div className="flex mt-6 md:mt-0 space-x-6">
            <BusinessLinks />
            <SocialLinks />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
